import React, { PropsWithChildren } from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { accordionWidthInColumns } from '../../Accordion/layout';
import { CardColumnSpanCalculator } from '../../CardGrid';
import AccordionCardGrid from '../../CardGrid/AccordionCardGrid';

const getDesktopColumnSpan = (totalCards: number): number => {
  const colSpanForSingleItemRow = 8;
  const colSpanForTwoItemRow = 5;

  return totalCards === 1 ? colSpanForSingleItemRow : colSpanForTwoItemRow;
};

export const columnSpanCalculator: CardColumnSpanCalculator = (
  index: number,
  totalCards: number
) => ({
  mobile: accordionWidthInColumns.mobile,
  tabletPortrait: accordionWidthInColumns.tabletPortrait,
  tabletLandscape: getDesktopColumnSpan(totalCards),
  desktop: getDesktopColumnSpan(totalCards),
});

const InfoCardAccordionGrid: React.FC<PropsWithChildren<ComponentProps>> = ({
  children,
  ...props
}) => (
  <AccordionCardGrid
    {...componentProps(props)}
    columnSpanCalculator={columnSpanCalculator}
    alignLeft={React.Children.count(children) !== 1}>
    {children}
  </AccordionCardGrid>
);

export default applyComponentTheme(InfoCardAccordionGrid, 'InfoCardAccordionGrid');
